import {
    Component,
    ChangeDetectionStrategy,
    ViewChildren,
    QueryList,
    Type,
    ViewEncapsulation,
} from '@angular/core';
import {
    FieldTypeConfig,
    FormlyFieldConfig,
    FormlyModule,
} from '@ngx-formly/core';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { FieldType, FormlyFieldProps } from '@ngx-formly/material/form-field';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormlySelectModule } from '@ngx-formly/core/select';

interface MultiCheckboxProps extends FormlyFieldProps {
    labelPosition?: 'before' | 'after';
}

export interface FormlyMultiCheckboxFieldConfig
    extends FormlyFieldConfig<MultiCheckboxProps> {
    type: 'mat-multicheckbox' | Type<MatMultiCheckboxTypeComponent>;
}

@Component({
    selector: 'mat-multicheckbox-type',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgFor,
        MatIconModule,
        FormlyModule,
        MatCheckboxModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        FormlySelectModule,
        AsyncPipe,
    ],
    template: `
        @if (formState.editMode) {
            <ng-container
                *ngFor="
                    let option of props.options
                        | formlySelectOptions: field
                        | async;
                    let i = index
                "
            >
                <mat-checkbox
                    [id]="id + '_' + i"
                    [formlyAttributes]="field"
                    [tabIndex]="props.tabindex"
                    [color]="props.color"
                    [labelPosition]="props.labelPosition"
                    [checked]="isChecked(option)"
                    [disabled]="formControl.disabled || option.disabled"
                    (change)="onChange(option.value, $event.checked)"
                >
                    {{ option.label }}
                </mat-checkbox>
            </ng-container>
        } @else {
            <div>
                <ng-container
                    *ngFor="let item of getOptionValues(); let i = index"
                >
                    <p class="mt-0.5">{{ item }}</p>
                </ng-container>
            </div>
        }
    `,
    host: {
        '[id]': 'id',
    },
})
export class MatMultiCheckboxTypeComponent extends FieldType<
    FieldTypeConfig<MultiCheckboxProps>
> {
    @ViewChildren(MatCheckbox) checkboxes!: QueryList<MatCheckbox>;

    override defaultOptions = {
        props: {
            hideFieldUnderline: true,
            floatLabel: 'always' as const,
            color: 'accent' as const, // workaround for https://github.com/angular/components/issues/18465
        },
    };

    onChange(value: any, checked: boolean) {
        this.formControl.markAsDirty();
        if (this.props.type === 'array') {
            this.formControl.patchValue(
                checked
                    ? [...(this.formControl.value || []), value]
                    : [...(this.formControl.value || [])].filter(
                          (o) => o !== value,
                      ),
            );
        } else {
            this.formControl.patchValue({
                ...this.formControl.value,
                [value]: checked,
            });
        }
        this.formControl.markAsTouched();
    }

    // TODO: find a solution to prevent scroll on focus
    override onContainerClick() {}

    isChecked(option: any) {
        const value = this.formControl.value;

        return (
            value &&
            (this.props.type === 'array'
                ? value.indexOf(option.value) !== -1
                : value[option.value])
        );
    }


    getOptionValues(): string[]{
      const values = this.formControl.value
      const options = this.props.options as Array<any>
      const results = [];

      if (options){
          for (let key in values){
              const vv = options.filter((x: any) => ( values[key] && x.value == key ))
              vv.length && results.push(vv[0].label)
          }
      }

      return results
  }


}
